module.exports = __webpack_public_path__ + "img/skin-cancer-melanoma-leaflet.afa0514d.jpg";